import { IBusinessEntityAddress } from '.';
import { httpService } from '../..';
import { IEntityWithMessages } from '../../services/HttpService';
import { IAddress } from '../address';
import { ApiUrls } from '../ApiUrls';
import { executeApiRequest } from '../asyncUtils';
import { BusinessListType, IBusinessEntityMin, IBusinessEntityMinDetails } from './businessEntityInterfaces';

export async function AddAddress(beAddy: IBusinessEntityAddress): Promise<IEntityWithMessages<IAddress[]>> {
  try {
    const response = await httpService.post(
      ApiUrls.businessEntity(beAddy.businessEntityId, 'Addresses'),
      beAddy.address
    );
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function UpdateAddress(beAddy: IBusinessEntityAddress): Promise<IEntityWithMessages<IAddress[]>> {
  try {
    const response = await httpService.put(
      ApiUrls.businessEntity(beAddy.businessEntityId, 'Addresses'),
      beAddy.address
    );
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function Search(request: { type: BusinessListType; zipcode: string }): Promise<IBusinessEntityMin> {
  try {
    const response = await httpService.get(ApiUrls.businessEntitySearch(request));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function FetchAxAddresses(businessEntityId: number): Promise<IAddress[]> {
  try {
    const response = await httpService.get(ApiUrls.businessEntity(businessEntityId, 'AxAddresses'));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updateBeCompetitors(value: { beId: number; competitorIds: number[] }) {
  return executeApiRequest<number[]>(() =>
    httpService.post(`${ApiUrls.businessEntity(value.beId, 'Competitors')}`, value.competitorIds)
  );
}

export async function fetchBeMinDetails(businessEntityId: number) {
  return executeApiRequest<IBusinessEntityMinDetails>(() =>
    httpService.get(ApiUrls.businessEntity(businessEntityId, 'MinDetails'))
  );
}

export async function updateBeRankType(value: { beId: number; rankTypeId: number }) {
  return executeApiRequest<{ businessEntityId: number; rankTypeId: number }>(() =>
    httpService.post(ApiUrls.businessEntity(value.beId, 'RankType'), value.rankTypeId)
  );
}

export async function updateBeMarketSegments(value: { beId: number; marketSegmentIds: number[] }) {
  return executeApiRequest<{ businessEntityId: number; marketSegments: number[] }>(() =>
    httpService.post(ApiUrls.businessEntity(value.beId, 'MarketSegments'), value.marketSegmentIds)
  );
}

export async function updateBeProductCategories(value: { beId: number; productCategoryIds: number[] }) {
  return executeApiRequest<{ businessEntityId: number; productCategoryIds: number[] }>(() =>
    httpService.post(ApiUrls.businessEntity(value.beId, 'ProductCategories'), value.productCategoryIds)
  );
}

export type BusinessEntityEndpoints =
  | 'Competitors'
  | 'Addresses'
  | 'AxAddresses'
  | 'RankType'
  | 'MinDetails'
  | 'MarketSegments'
  | 'ProductCategories';
